"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Loading = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_get_1 = require("@styled-system/theme-get");
var Cell_1 = require("../Cell");
var incoming = (0, styled_components_1.keyframes)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  0% {\n    transform: translateX(-100%);\n  }\n\n  50% {\n    transform: translateX(200%);\n  }\n\n  100% {\n    transform: translateX(-100%);\n  }\n"], ["\n  0% {\n    transform: translateX(-100%);\n  }\n\n  50% {\n    transform: translateX(200%);\n  }\n\n  100% {\n    transform: translateX(-100%);\n  }\n"])));
var Container = (0, styled_components_1.default)(Cell_1.Cell)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: relative;\n  overflow: hidden;\n\n  ", "\n"], ["\n  position: relative;\n  overflow: hidden;\n\n  ", "\n"])), function (_a) {
    var loading = _a.loading;
    return loading && (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      &::after {\n        content: \"\";\n        position: absolute;\n        bottom: 0;\n        left: 0;\n        width: 50%;\n        height: 2px;\n        animation: ", " 1.5s ease infinite;\n        background-color: ", ";\n      }\n    "], ["\n      &::after {\n        content: \"\";\n        position: absolute;\n        bottom: 0;\n        left: 0;\n        width: 50%;\n        height: 2px;\n        animation: ", " 1.5s ease infinite;\n        background-color: ", ";\n      }\n    "])), incoming, (0, theme_get_1.themeGet)("colors.primary"));
});
var Loading = function (_a) {
    var children = _a.children, _b = _a.loading, loading = _b === void 0 ? true : _b, rest = __rest(_a, ["children", "loading"]);
    return (react_1.default.createElement(Container, __assign({ loading: loading }, rest), children !== null && children !== void 0 ? children : react_1.default.createElement(react_1.default.Fragment, null, "\u00A0")));
};
exports.Loading = Loading;
exports.Loading.displayName = "Loading";
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=Loading.js.map